$(function () {
  app.dom = {
    header: $('#header'),
    main: $('#main'),
    footer: $('#footer'),
  };

  app.response.callback = {
    desktop: function () {
      // 桌面端
      shareSNS();
    },
    padH: function () {
      // pad横版
      // footerWechat();
    },
    padV: function () {
      // pad竖版
      // footerWechat();
    },
    mobile: function () {
      // 手机端
      // footerWechat();
    },
    all: function () {
      // 全端
      mainMinHeight();
      shrinkMenu();
      menu();
      returnTop();
      clickStopPropagation();
      popQrCode();
      // location.hash.indexOf('debugRow') != -1 && debugRow();
    },
  };
  app.pageInit();
  app.method = {
    cmsPageInit: cmsPageInit,
    itemSetClassHover: itemSetClassHover,
  };

  function mainMinHeight() {
    var $header = $('#header');
    var $footer = $('#footer');
    var $headerHeight = $header.outerHeight();
    var $footHeight = $footer.outerHeight();
    app.log($(window).height(), $headerHeight, $footHeight);
    if ($(window).height() - $headerHeight - $footHeight > 0) {
      $('#main').css('min-height', $(window).height() - $headerHeight - $footHeight);
    }
  }
  $(window).resize(function () {
    mainMinHeight();
  });

  function shrinkMenu() {
    var $header = $('#header');
    var $headerHeight = $header.outerHeight();
    // console.log($headerHeight)
    $(window).scroll(function () {
      var p = $(this).scrollTop();
      if (p > $headerHeight + 20) {
        $('html').addClass('shrink-nav');
      } else {
        $('html').removeClass('shrink-nav');
      }
    });
  }

  function menu() {
    console.log(app.scroll.width);
    $('.real-menu').height(app.screen.vh);
    // 打开菜单
    var isShrink = false;
    $('#header .has-sub>a,.i-nav-a,.i-nav').click(function () {
      $('html,body').addClass('noscroll');
      $('.real-menu').css('padding-right', app.scroll.width + 'px');
      $('body').css('padding-right', app.scroll.width + 'px');
      app.m.pdScroll($('.real-menu'), $('.real-menu .list-content'));
      app.m.bfScroll.afterOpen();
      $('html').addClass('menu-open');
      if ($('html').hasClass('shrink-nav')) {
        $('html').removeClass('shrink-nav');
        isShrink = true;
      }
      if (timer) {
        clearTimeout(timer);
      }
      var timer = setTimeout(function () {
        $('html').addClass('show-nav');
      }, 350);
    });
    // 左菜单子菜单打开
    $('.left-list .has-sub>a').click(function () {
      $('.real-menu .nav-list>li').removeClass('open');
      $('.real-menu .nav-list>li').find('.sub-list').height(0);
      var i = $(this).parent().attr('data-i');
      var ele = $('.real-menu .left-nav>li').eq(i);
      // console.log(i,$(".real-menu .left-nav>li").eq(i))
      ele.addClass('open');
      ele.find('.sub-list').height(ele.find('.sub-list').childAllHeight());
    });
    // 右菜单子菜单打开
    $('.right-list .has-sub>a').click(function () {
      $('.real-menu .nav-list>li').removeClass('open');
      $('.real-menu .nav-list>li').find('.sub-list').height(0);
      var i = $(this).parent().attr('data-i');
      var ele = $('.real-menu .right-nav>li').eq(i);
      // console.log(i,$(".real-menu .right-nav>li").eq(i))
      ele.addClass('open');
      ele.find('.sub-list').height(ele.find('.sub-list').childAllHeight());
    });
    $('#header .has-sub a,.real-menu .has-sub a').click(function (e) {
      var $this = $(this);
      if ($this.parent().hasClass('has-sub')) {
        if (e && e.preventDefault) e.preventDefault();
        else {
          window.event.returnValue = false;
        }
      }
    });

    // 打开、关闭子菜单
    $('.real-menu .nav-list>li').each(function () {
      $(this).click(function () {
        var $this = $(this);
        if (!$this.hasClass('open')) {
          $('.nav-list>li').removeClass('open');
          $this.addClass('open');
          $('.nav-list>li').find('.sub-list').height(0);
          $this.find('.sub-list').height($this.find('.sub-list').childAllHeight());
        } else {
          $('.nav-list>li').removeClass('open');
          $this.removeClass('open');
          $this.find('.sub-list').height(0);
        }
        console.log($this);
      });
      $(this)
        .children('a')
        .click(function (e) {
          var $this = $(this);
          if ($this.parent().hasClass('has-sub')) {
            if (e && e.preventDefault) e.preventDefault();
            else {
              window.event.returnValue = false;
            }
          }
        });
    });

    // 关闭菜单
    $('.real-menu .i-close-a').click(function () {
      $('html,body').removeClass('noscroll');
      $('html').removeClass('show-nav');
      if (isShrink) {
        $('html').addClass('shrink-nav');
      }
      if (timer) {
        clearTimeout(timer);
      }
      var timer = setTimeout(function () {
        $('html').removeClass('menu-open');
      }, 350);
      $('body').css('padding-right', 0);
      $('.real-menu').css('padding-right', 0);
      app.m.bfScroll.beforeClose();
    });

    // 全局搜索
    $('.global-input-search').bind('keyup', function () {
      if ($(this).val().length >= 1) {
        $('.search-list').removeClass('search-list-open');

        $('.loading').addClass('loading-show');
        // $('.search-list').addClass('search-list-open')
        loading();
      } else {
        $('.search-list').removeClass('search-list-open');
        $('.loading').removeClass('loading-show');
      }
      // if ($(this).val() == "") {

      // }
      // $(".list").niceScroll({
      //   cursorcolor: "#d9d9d9"
      // })
    });
    $('.global-i-search').on('click', function () {
      $('.global-search').addClass('global-search-show');
      $('html').addClass('noscroll');
      $('body').addClass('noscroll');
    });
    $('.i-close-a').on('click', function () {
      $('.global-search').removeClass('global-search-show');
      $('html').removeClass('noscroll');
      $('body').removeClass('noscroll');
      $('.global-input-search').val('');
      $('.search-list').removeClass('search-list-open');
    });
  }

  function loading() {
    setTimeout(function () {
      $('.search-list').addClass('search-list-open');
      $('.loading').removeClass('loading-show');
      $('.list').niceScroll({
        cursorcolor: '#d9d9d9',
        horizrailenabled: false,
      });
    }, 1000);
  }

  function returnTop() {
    $('.returnTop').click(function () {
      $('html,body').animate(
        {
          scrollTop: '0',
        },
        1000
      );
    });
  }

  function footerWechat(e) {
    console.log(1);
    $('#footer .i-wechat-a,.person-detail .i-wechat').click(function () {
      app.m.pdScroll($('.wechat-wrapper'), $('.wechat-box-wrapper .img'));
      app.m.bfScroll.afterOpen();
      $('html').addClass('footer-wechat-open');
    });
    $('.wechat-wrapper .i-close-a').click(function () {
      $('html').removeClass('footer-wechat-open');
      app.m.bfScroll.beforeClose();
    });
  }

  function clickStopPropagation() {
    $body.on('click', '.stopPropagation', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  // 显示全片qrCode（非桌面端）
  function popQrCode() {
    var $pop = $(
      '<div class="pop-qrcode"><i class="i i-close-a"></i><h4></h4><div class="img"><img src="" alt=""></div></div>'
    );
    $pop.appendTo($('body'));
    $pop.$title = $pop.find('h4');
    $pop.$img = $pop.find('img');

    $pop.show = function (src, title) {
      $pop.css({
        display: 'flex',
      });
      $pop.$title.text(title);
      $pop.$img.attr('src', src);
      setTimeout(function () {
        $pop.addClass('pop-qrcode--show');
      });
    };
    $pop.hide = function () {
      $pop.removeClass('pop-qrcode--show');
      setTimeout(function () {
        $pop.removeAttr('style');
      }, 350);
    };
    $pop.find('.i-close-a').on('click', $pop.hide);

    $('#footer .links-wrap')
      .find('img')
      .closest('a')
      .on('click', function () {
        var $img = $(this).find('img');
        $pop.show($img.attr('src'), $img.attr('title'));
      });
  }

  // sns分享
  function shareSNS() {
    if ($('#share').length != 0) {
      socialShare('#share', {
        sites: ['wechat', 'weibo', 'facebook', 'twitter', 'instagram'],
        // image: "url",
        // wechatQrcodeTitle: $("#share").data("wechat-title")?$("#share").data("wechat-title"):"分享至朋友圈",
        wechatQrcodeHelper: '',
        wechatQrcodeTitle: '',
        wechatQrcodeSize: 170,
      });
      $('.share-btn').on('click', function () {
        app.m.pdScroll($('.aside-share-wrap'), $('.share-content'));
        app.m.bfScroll.afterOpen();
        $('.aside-share-wrap').addClass('open');
      });
      $('.close-share').on('click', function () {
        $('.aside-share-wrap').removeClass('open');
        app.m.bfScroll.beforeClose();
      });
    }
  }

  // 屏幕旋转时刷新页面
  // $window.on("orientationchange", function() {
  //   window.location.reload();
  // });

  // 解决safari自带放大功能：阻止双击放大
  function disableScaling() {
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });
    document.addEventListener('dblclick', function (e) {
      e.preventDefault();
    });
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    var lastTouchEnd = 0;
    document.addEventListener(
      'touchend',
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  }
  disableScaling();

  // cmsPage
  function cmsPageInit() {
    // table
    $('.table-response').each(function () {
      var $table = $(this),
        $tr = $table.find('tbody tr'),
        td = $tr.find('td').wrapInner('<span class="table-response-td"></span>'),
        th = $table.find('thead th').wrapInner('<span class="table-response-th"></span>'),
        $td = td.find('span'),
        $th = th.find('span'),
        rowCont = th.length;
      $td.each(function (i) {
        $(this).before($th.eq(i % rowCont).clone());
      });
    });

    // swiper-cms
    $('.swiper-cms').each(function () {
      var $this = $(this);
      var $cmsSwiperLen = $this.find('.swiper-slide').length;
      var navigation = $this.find('.swiper-button');
      var $pagination = $this.find('.swiper-pagination');
      var onOff = true;
      if ($cmsSwiperLen <= 1) {
        onOff = false;
        navigation.hide();
        $pagination.hide();
        $this.addClass('not-pag');
      }
      new Swiper($this, {
        slidesPerView: 1,
        simulateTouch: onOff,
        allowTouchMove: onOff,
        observer: true,
        observeParents: true,
        effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: $pagination,
          clickable: true,
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
      });
    });

    // 腾讯视频
    $('.cms-video-qq').each(function () {
      var $this = $(this),
        $onOff = false,
        player = new Txplayer({
          containerId: $this.attr('id'),
          vid: $this.data('vid'),
          width: '100%',
          height: '100%',
        });
    });
  }

  function itemSetClassHover(opt) {
    $(opt.item).each(function () {
      var $this = $(this),
        classHover = opt.classHover;

      function addClassHover() {
        $this.addClass(classHover);
      }

      function removeClassHover() {
        $this.removeClass(classHover);
      }
      $this.find(opt.find).hover(addClassHover, removeClassHover);
    });
  }

  // 对齐设计稿参照线
  function debugRow() {
    var htmlCodes = [
      '<div class="grid-row-line">',
      ' <div class="container">',
      '    <div class="row">',
      '    <div class="col"></div>',
      '    <div class="col"></div>',
      '    <div class="col"></div>',
      '    <div class="col"></div>',
      '    <div class="col d-none d-md-block"></div>',
      '    <div class="col d-none d-md-block"></div>',
      '    <div class="col d-none d-lg-block"></div>',
      '    <div class="col d-none d-lg-block"></div>',
      '    <div class="col d-none d-lg-block"></div>',
      '    <div class="col d-none d-lg-block"></div>',
      '    <div class="col d-none d-lg-block"></div>',
      '    <div class="col d-none d-lg-block"></div>',
      '    </div>',
      ' </div>',
      '</div>',
    ].join('');
    $(htmlCodes).appendTo($body);
  }
});
